export default {
  RUNTIME_MAX_SPEED: "The maximum speed for an object is {MAX_SPEED}",
  RUNTIME_MAX_CLONES:
    "You can only clone up to {number} objects at the same time.",
  RUNTIME_INVALID_NAME: "There is already an object named {name}",
  RUNTIME_EMPTY_NAME: "You need to specify a name",
};
